import calculatePizzaPrice from './calculatePizzaPrice';
import formatMoney from './formatMoney';
import pizzaSizeString from './pizzaSizeString';

const attachNamesAndPrices = (order, pizzas) =>
  order.map((item) => {
    const pizza = pizzas.find((p) => p.id === item.id);
    return {
      ...item,
      name: pizza.name,
      size: pizzaSizeString(item.size),
      thumbnail: pizza.image.asset.fluid.src,
      price: formatMoney(calculatePizzaPrice(pizza.price, item.size)),
    };
  });
export default attachNamesAndPrices;
